module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/locks/locks-list/locks-list.component.css
// module id = ./src/app/locks/locks-list/locks-list.component.css
// module chunks = main